export default __webpack_public_path__ + "static/media/chatbg.5c08aa56.png";